import React from "react";


function Footer() {
  return (
    <footer>
      <p>© 2021 Searchspring API - All rights reserved.</p>
    </footer>
  )
}

export default Footer;
